export default [
    {
        path: '/enroll',
        name: '在线报名',
        component: r => require.ensure([], () => r(require('@/views/enroll/index')), 'user')
    },
]


// WEBPACK FOOTER //
// ./src/router/routers/enroll.js